export var apiURI = process.env.REACT_APP_API_URL || '/api';
